import { HIGHLIGHT_CLASS, HIGHLIGHT_DURATION_MS } from './TeamChatFieldAnchor.constants';

export const scrollToAndHighlightAnchor = anchor => {
  if (!anchor || typeof document === 'undefined') {
    return;
  }

  const element = document.getElementById(anchor);

  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.classList.add(HIGHLIGHT_CLASS);
  window.setTimeout(() => element.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_DURATION_MS);
};
